import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import ru from 'vuetify/lib/locale/ru';

// import themeColors from '@/styles/colors';
import ThemeAutocomplete from '@/components/common/ThemeAutocomplete.vue';
import ThemeBtn from '@/components/common/ThemeBtn.vue';
import ThemeDialog from '@/components/common/ThemeDialog.vue';
import ThemeLoader from '@/components/common/ThemeLoader.vue';
import ThemeSelect from '@/components/common/ThemeSelect.vue';
import ThemeTab from '@/components/common/ThemeTab.vue';
import ThemeTabs from '@/components/common/ThemeTabs.vue';
import ThemeTextarea from '@/components/common/ThemeTextarea.vue';
import BaseInput from '@/components/ui/BaseInput.vue';

// import IconComponent from '@/components/IconComponent.vue';

Vue.use(Vuetify);

// Обертки над компонентами Vuetify для применения настроек интерфейса по умолчанию
Vue.component('ThemeBtn', ThemeBtn);
Vue.component('ThemeTextField', BaseInput);
Vue.component('ThemeSelect', ThemeSelect);
Vue.component('ThemeTextarea', ThemeTextarea);
Vue.component('ThemeAutocomplete', ThemeAutocomplete);
Vue.component('ThemeDialog', ThemeDialog);
Vue.component('ThemeLoader', ThemeLoader);
Vue.component('ThemeTabs', ThemeTabs);
Vue.component('ThemeTab', ThemeTab);

export default new Vuetify({
  lang: {
    locales: { ru },
    current: 'ru',
  },
  theme: {
    dark: false,
    options: {
      customProperties: false,
      variations: false,
    },
    disable: true
  },
  icons: {
    iconfont: 'mdiSvg',
  },
  breakpoint: {
    thresholds: {
      xs: 600,
      sm: 900,
      md: 1024,
      lg: 1440,
      xl: 1920,
    },
    mobileBreakpoint: 'sm',
  },
});
